import { useNavigate } from "react-router-dom";
import { IActionButton, ITableFilter } from "../../../../interfaces";
import { useEffect, useState } from "react";
import { PATIENT_FILTER } from "../../../../enums";
import { useDebounce } from "use-debounce";
import SearchPatient from "../../../../assets/img/svg/searchPation.svg";
import searchIcon from "../../../../assets/img/svg/searchicon.svg";
import AddUser from "../../../../assets/img/svg/addUser.svg";
import { RiFilter2Fill } from "react-icons/ri";
interface ITableTooltipProps {
  title: string;

  searchHandler?: (search: string, filters: any) => void;
  isLoading?: boolean;
  filters?: Array<ITableFilter>;
  actionButtons?: Array<IActionButton>; // eg: add new user
}

/**
 *
 * @param props
 * @returns
 */
export const TableTooltip = ({
  searchHandler,
  isLoading,
  filters,
  actionButtons,
  title,
}: ITableTooltipProps) => {
  const nav = useNavigate();

  const [dateRange, setDateRange] = useState<any>([null, null]);

  const [searchTerm, setSearchTerm] = useState<string>("");

  const [displayFilter, setDisplayFilter] = useState<boolean>(false);

  const [location, setLocation] = useState<PATIENT_FILTER>(
    PATIENT_FILTER.CENTER_PATIENTS
  );
  const [debouncedValuePatient] = useDebounce(searchTerm, 1000);

  useEffect(() => {
    console.log("search location was changed", location);
  }, [location]);
  // trigger searching
  useEffect(() => {
    if (searchHandler)
      searchHandler(debouncedValuePatient, { dateRange, location });
  }, [debouncedValuePatient, dateRange, location, searchHandler]);

  return (
    <div>
      <div className="grid gap-3 justify-items-start lg:flex lg:justify-between lg:items-center">
        <div className="flex justify-start items-center gap-2 w-max">
          <img src={SearchPatient} alt="SearchPatient" className="h-7 w-7" />
          <p className="text-[#50799E] font-semibold text-xl">{title || ""}</p>
        </div>

        {/* search input */}
        {searchHandler && (
          <div className="flex items-center">
            <div className="flex flex-col">
              <input
                className="px-4 pl-9 ml-3 w-auto lg:w-[25rem] focus:border-none active:border-none h-10 border border-[#50799E] 
                        rounded-full focus:border-[#50799E] active:border-[#50799E]"
                placeholder={"search"}
                type="text"
                onChange={(e: any) => {
                  setSearchTerm(e.target.value);
                }}
              />
              {isLoading && (
                <div className="absolute w-auto lg:w-[25rem] h-10 pl-5 py-2">
                
                </div>
              )}
            </div>
            <span className="relative right-12 justify-center items-center mx-2 w-20 font-medium rounded-full text-sm py-1 text-center">
              <img src={searchIcon} alt="" className="w-6 h-6" />
            </span>

            {!!filters && (
              <div className="relative right-20">
                <button
                  onClick={() => setDisplayFilter(!displayFilter)}
                  className="flex justify-center items-center rounded-full font-semibold text-[#1AA5C0] border px-4 py-1.5 border-[#50799E] gap-2"
                >
                  <RiFilter2Fill color="#50799E" />
                  {"filter"}
                </button>
              </div>
            )}
            {/* <small>{`${totalResults} resultats trouvés`}</small> */}
          </div>
        )}

        {actionButtons &&
          actionButtons.map((button: IActionButton) => (
            <>
              <button
                className="flex justify-center items-center bg-[#1AA5C0] rounded-full text-white font-semibold px-5 py-1 gap-2"
                onClick={button.handler}
              >
                <img src={AddUser} alt="AddUser" className="w-4 h-4" />
                <p>{button.text}</p>
              </button>
            </>
          ))}
      </div>

      {displayFilter && (
        <div className="grid lg:grid-cols-2">
          <div className="flex justify-start items-center gap-3">
  
          </div>
        </div>
      )}
    </div>
  );
};
